import {AfterViewInit, Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-base-after-view-init',
    templateUrl: './base-after-view-init.component.html',
    styleUrls: ['./base-after-view-init.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class BaseAfterViewInitComponent implements AfterViewInit {

    childrenInitialized = false;

    ngAfterViewInit(): void {
        setTimeout(() => { this.childrenInitialized = true; });
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/base-components/after-view-init/base-after-view-init.component.ts